import { render } from "./klondike.vue?vue&type=template&id=dc001960&ts=true"
import script from "./klondike.vue?vue&type=script&lang=ts"
export * from "./klondike.vue?vue&type=script&lang=ts"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__